import http from './http-common'

export const getAllActives = () => http.get(`/actives/all`)